import React from "react";
import { Link } from 'gatsby'

export default function Footer(pageContext) {

    var previousPageLink, nextPageLink = null

    if ((pageContext.pageContext !== undefined) && ("previousPage" in pageContext.pageContext)) {
        previousPageLink = pageContext.pageContext.previousPage !== null ? 
            <Link to={pageContext.pageContext.previousPage.path}>
                &larr; { pageContext.pageContext.previousPage.title }
            </Link>
                :
            <Link to="/">
                &larr; Home
            </Link>
        nextPageLink = pageContext.pageContext.nextPage !== null ? 
            <Link to={pageContext.pageContext.nextPage.path}>
                { pageContext.pageContext.nextPage.title } &rarr;
            </Link>
                :
            <Link to="/">
                Home &rarr;
            </Link>
            
    }

    return (
        <footer>
            <div>
                { previousPageLink }
            </div>
            <div>
                <a href='#top'>&uarr; Back to top</a>
            </div>
            <div>
                { nextPageLink }
            </div>
        </footer>
  )
}